// removed by extract-text-webpack-plugin
module.exports = {"header":"_1cyy-ZKyEfhPlkKWicJRau","subheader":"_2RCvYEjT_iTKPzDMN2xWc","row":"_3wG8SdTsz6KNiyTewLTRW_","name":"_35_DptpEnlsoBLi65s3qcc","error":"ODjzkL9_w4Gy3aUxHTuJl"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/RecipientsImportReport/RecipientsImportReport.scss
// module id = 1372
// module chunks = 1